import { render, staticRenderFns } from "./MenuGroups.vue?vue&type=template&id=3bf2e6eb"
import script from "./MenuGroups.vue?vue&type=script&lang=ts"
export * from "./MenuGroups.vue?vue&type=script&lang=ts"
import style0 from "./MenuGroups.vue?vue&type=style&index=0&id=3bf2e6eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports